var React = require('react');

function QuoteOpen (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M24 23.0661H14.428V13.4942C14.428 9.41634 15.2374 6.14786 16.856 3.68872C18.4747 1.22957 20.856 0 24 0V4.48249C20.8872 4.48249 19.3307 7.48638 19.3307 13.4942H24V23.0661ZM9.57198 23.0661H0V13.4942C0 9.41634 0.809338 6.14786 2.42802 3.68872C4.04669 1.22957 6.42802 0 9.57198 0V4.48249C6.42802 4.48249 4.85603 7.48638 4.85603 13.4942H9.57198V23.0661Z","fill":"#FFD633"}));
}

QuoteOpen.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none"};

module.exports = QuoteOpen;

QuoteOpen.default = QuoteOpen;
